import { Injectable, signal, WritableSignal } from '@angular/core';
import { BaseService } from '../base.service';
import {
  HttpTransportType,
  HubConnection,
  HubConnectionBuilder,
  HubConnectionState,
  LogLevel,
} from '@microsoft/signalr';

@Injectable({
  providedIn: 'root',
})
export class SignalRService extends BaseService {
  private hubConnection!: HubConnection;
  notifications: WritableSignal<NotificationI[]> = signal([]);
  constructor() {
    super();
  }

  startConnection(token: string) {
    if (this.hubConnection?.state === HubConnectionState.Disconnected) {
      return;
    }
    this.hubConnection = new HubConnectionBuilder()
      // .withUrl(`${this.hubUrl}?access_token=${token}`)
      .withUrl(`${this.apiUrl}notifications`, {
        accessTokenFactory: () => {
          return token; // make sure this returns the actual token string
        },
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets,
      })
      .configureLogging(LogLevel.Debug)
      .withAutomaticReconnect()
      .build();

    this.hubConnection
      .start()
      .catch((err) =>
        console.error('Error while starting SignalR connection: ', err)
      );

    this.hubConnection.on(
      'ReceiveNotification',
      (message: NotificationI[] | NotificationI) => {
        console.log('message', message);
        if (Array.isArray(message)) {
          this.notifications.update((values) => [...values, ...message]);
        } else {
          this.notifications.set([message]);
        }
      }
    );
  }
  destroyConnection(): void {
    if (this.hubConnection) {
      this.hubConnection
        .stop()
        .catch((err) =>
          console.error('Error while stopping SignalR connection:', err)
        );
    }
  }
}
export interface NotificationI {
  id: string;
  message: string;
}
